import type { StrategyDescriptionTag } from '../services/api';

interface ApiResponse {
  success: boolean;
  error?: string;
}

export interface PositionStrategyTagApi {
  getStrategyDescriptionTags(): Promise<ApiResponse & { data?: { tags: StrategyDescriptionTag[] } }>;
  createStrategyDescriptionTag(payload: {
    name: string;
    description?: string;
    color?: string;
  }): Promise<ApiResponse>;
  updateStrategyDescriptionTag(tagId: number, payload: {
    name?: string;
    description?: string | null;
    color?: string | null;
  }): Promise<ApiResponse>;
  deleteStrategyDescriptionTag(tagId: number): Promise<ApiResponse>;
  updatePositionMetadata(
    positionKey: string,
    strategyName: string | null,
    tagIds: number[],
  ): Promise<ApiResponse>;
}

export interface StrategyTagForm {
  editingTagId: number | null;
  name: string;
  description: string;
  color: string;
}

export class PositionStrategyTagService {
  private readonly api: PositionStrategyTagApi;

  constructor(api: PositionStrategyTagApi) {
    this.api = api;
  }

  listTags() {
    return this.api.getStrategyDescriptionTags();
  }

  saveTag(form: StrategyTagForm) {
    const name = form.name.trim();
    const description = form.description.trim();
    if (form.editingTagId !== null) {
      return this.api.updateStrategyDescriptionTag(form.editingTagId, {
        name,
        description: description || null,
        color: form.color,
      });
    }
    return this.api.createStrategyDescriptionTag({
      name,
      description: description || undefined,
      color: form.color,
    });
  }

  deleteTag(tagId: number) {
    return this.api.deleteStrategyDescriptionTag(tagId);
  }

  savePositionMetadata(positionKey: string, strategyName: string, tagIds: number[]) {
    return this.api.updatePositionMetadata(
      positionKey,
      strategyName.trim() || null,
      tagIds,
    );
  }
}
